module.exports = __webpack_public_path__ + "img/checked_color_on.7fba7c5f.svg";